import { render } from "./DestinationRowActions.vue?vue&type=template&id=0ad9070e"
import script from "./DestinationRowActions.vue?vue&type=script&setup=true&lang=js"
export * from "./DestinationRowActions.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/ui/PlatformList/DestinationRowActions.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0ad9070e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0ad9070e', __exports__)) {
    api.reload('0ad9070e', __exports__)
  }
  
  module.hot.accept("./DestinationRowActions.vue?vue&type=template&id=0ad9070e", () => {
    api.rerender('0ad9070e', render)
  })

}


export default __exports__